import {priority} from '@priority-software/priority-proto-api/lib';

import {CUSTOMER_FORM_NAME, RELEVANT_FIELDS_NAMES, MAKE_CUST_NAME} from './consts';
import {getColumns, getFormStatuses, setFormActions} from '../Form/actions/form';
import {Column, Form} from '../../stores/Form';
import {startForm, action, actionEnd} from '../../services/form/form';
import {buildServerCall} from '../../services/wcfService';
import {getConnection} from '../../_shared/GWTBridge/invoke/procMain';
import {addNewScreen} from '../Form/actions/screen';

export const getRelevantColumns = (columns: Column[]): Column[] =>
    !columns
        ? []
        : columns
              .filter(col => RELEVANT_FIELDS_NAMES.includes(col.Name))
              .sort(
                  (a, b) =>
                      RELEVANT_FIELDS_NAMES.indexOf(a.Name) - RELEVANT_FIELDS_NAMES.indexOf(b.Name)
              );

export const openCustomerForm = async (): Promise<Form> => {
    try {
        const startRs: priority.netitems.form.StartRs = await startForm(CUSTOMER_FORM_NAME);
        const columnsRs: priority.netitems.form.ColumnsRs = await getColumns(
            startRs.Session,
            CUSTOMER_FORM_NAME
        );

        const form: Form = new Form(CUSTOMER_FORM_NAME, startRs, columnsRs, 0, null);
        await setFormActions(form);
        await getFormStatuses(form);
        addNewScreen(form, null, true);
        return form;
    } catch (error) {
        console.log('start new customer form error', error);
        throw new Error('error');
    }
};

export const executeDirectActivation = async (form: Form) => {
    const {records, session, currentRow} = form;

    const keys = records[form.currentRow].keys;
    const scrLine = currentRow;
    const actionRes = await action(session, scrLine, keys);

    const link = {
        link: actionRes.LinkFile,
        linkid: actionRes.LinkID,
        table: actionRes.Table
    };

    const methodName = 'ProcStartActivate';
    const reason = 'ProcStartActivate';

    const parameters = {
        type: ['P'],
        ename: [MAKE_CUST_NAME],
        table: [link.table],
        link: [link.link],
        linkid: [link.linkid],
        avoidmessages: ['false']
    };

    await buildServerCall(methodName, parameters, reason, false, getConnection);

    const actionEndRes = await actionEnd(session);

    return actionEndRes?.Record?.Fields[0].Value.Str;
};
